import { Capacitor } from "@capacitor/core";
import { Haptics, ImpactStyle, NotificationType } from "@capacitor/haptics";

export { ImpactStyle, NotificationType };

/* The Haptics plugin ships a web implementation, so isPluginAvailable() passes in
   browsers — but that web implementation throws where navigator.vibrate is missing
   (e.g. Firefox). Haptic feedback is best-effort: failures must never reject into
   awaiting call sites (FAB menus, submit flows). */
async function runHaptics(action: () => Promise<void>): Promise<void> {
  if (!Capacitor.isPluginAvailable("Haptics")) {
    return;
  }
  try {
    await action();
  } catch {
    // Platform without haptic/vibration support — ignore.
  }
}

export async function hapticImpact(style: ImpactStyle = ImpactStyle.Light): Promise<void> {
  await runHaptics(() => Haptics.impact({ style }));
}

export async function hapticNotification(type: NotificationType): Promise<void> {
  await runHaptics(() => Haptics.notification({ type }));
}

export async function hapticSelection(): Promise<void> {
  await runHaptics(async () => {
    await Haptics.selectionStart();
    await Haptics.selectionChanged();
    await Haptics.selectionEnd();
  });
}

export async function hapticVibrate(durationMs = 200): Promise<void> {
  await runHaptics(() => Haptics.vibrate({ duration: durationMs }));
}
